




















































































import Vue from "vue";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueTinySlider from "vue-tiny-slider";
export default Vue.extend({
  components: {
    "tiny-slider": VueTinySlider,
    IconAngleLeft: () => import("@/assets/static/icons/angle-left.svg"),
    IconAngleRight: () => import("@/assets/static/icons/angle-right.svg"),
    LogoUtOriginal: () => import("@/assets/static/logo/ut-original.svg"),
    EmojiDisgust: () => import("@/assets/static/emoji/v2/emoji-disgust.svg"),
    EmojiHappy: () => import("@/assets/static/emoji/v2/emoji-happy.svg"),
    EmojiNetral: () => import("@/assets/static/emoji/v2/emoji-netral.svg"),
    EmojiSad: () => import("@/assets/static/emoji/v2/emoji-sad.svg"),
    EmojiSurprise: () => import("@/assets/static/emoji/v2/emoji-surprise.svg"),
  },
  data() {
    return {
      currentIndex: 0,
      // eslint-disable-next-line
      tinySlider: 0 as any
    };
  },
  methods: {
    nextPage: function () {
      // eslint-disable-next-line
      // let tinySlider = (this.$refs.tinySlider as any).slider;
      if (this.currentIndex < 9) {
        this.tinySlider.getInfo().index + 1;
        this.tinySlider.goTo(this.tinySlider.getInfo().index + 1);
      } else {
        this.$router.push({ name: "VoteSuccess" });
      }
    },
    prevPage: function () {
      // eslint-disable-next-line
      if (this.currentIndex > 0) {
        this.currentIndex = this.tinySlider.getInfo().index - 1;
        this.tinySlider.goTo(this.tinySlider.getInfo().index - 1);
      }
    },
    getInfo: function () {
      // eslint-disable-next-line
      this.currentIndex = this.tinySlider.getInfo().index;
    },
  },
  mounted() {
    // eslint-disable-next-line
    this.tinySlider = (this.$refs.tinySlider as any).slider;
  },
});
